import React from 'react';

/** Rodapé fixo dos surveys — botão sempre visível no celular. */
const CompleteProfileFormActions = ({
  error,
  hint,
  showHint,
  missingLabels,
  loading,
  canSubmit,
  submitLabel,
  loadingLabel = 'Enviando...',
}) => (
  <div className="complete-profile-form-actions">
    {error ? <div className="complete-profile-error">{error}</div> : null}
    {Array.isArray(missingLabels) && missingLabels.length > 0 && !loading ? (
      <ul className="complete-profile-missing-list">
        {missingLabels.map((label) => (
          <li key={label}>{label}</li>
        ))}
      </ul>
    ) : null}
    {showHint && !loading && (!missingLabels || missingLabels.length === 0) ? (
      <p className="complete-profile-field-hint complete-profile-actions-hint">{hint}</p>
    ) : null}
    <button
      type="submit"
      className={`complete-profile-submit${canSubmit ? ' complete-profile-submit--ready' : ''}`}
      disabled={loading}
      aria-disabled={loading}
    >
      {loading ? loadingLabel : submitLabel}
    </button>
  </div>
);

export default CompleteProfileFormActions;
